<ng-container *seiraIfViewportSize="'desktop'">
	<seira-listagem-notificacoes-tab></seira-listagem-notificacoes-tab>
	<header id="lp-header" [class.scrolled]="isScrolled" *ngIf="mostrarLogos">
		<div class="header-logo-side">
			<img
				src="assets/images/logos/aesa-branco.png"
				alt="AESA"
				class="logo-lateral logo-aesa" />
		</div>

		<div class="header-center">
			<a routerLink="/" style="cursor: pointer;">
				<img
					src="assets/images/logo_1.svg"
					alt="SEIRA"
					class="logo-seira" />
			</a>
			<span class="header-subtitle">
				Sistema Estadual de Informações de Riscos Agrohidroclimáticos
			</span>
		</div>

		<div class="header-logo-side">
			<img
				src="assets/images/logos/governo-pb-branco.png"
				alt="Governo da Paraíba"
				class="logo-lateral logo-governo" />
		</div>
	</header>
	<div
		class="logos-laterais"
		[class.fechado]="logosOcultas"
		*ngIf="mostrarLogos">
		<button class="toggle-button" (click)="logosOcultas = !logosOcultas">
			<i
				class="ph"
				[ngClass]="logosOcultas ? 'ph-caret-left' : 'ph-caret-right'"></i>
		</button>

		<ng-container *ngIf="!logosOcultas">
			<a
				href="https://paraiba.pb.gov.br/"
				target="_blank"
				rel="noopener noreferrer">
				<img src="assets/images/logos/governo_pb.png" alt="governo" />
			</a>
			<a
				href="http://www.aesa.pb.gov.br/"
				target="_blank"
				rel="noopener noreferrer">
				<img src="assets/images/logos/aesa.png" alt="aesa" />
			</a>
			<a
				href="https://cooperar.pb.gov.br/"
				target="_blank"
				rel="noopener noreferrer">
				<img src="assets/images/logos/cooperar.png" alt="cooperar" />
			</a>
			<a
				href="https://www.worldbank.org/ext/en/home"
				target="_blank"
				rel="noopener noreferrer">
				<img src="assets/images/logos/banco_mundial.png" alt="banco" />
			</a>
		</ng-container>
	</div>
</ng-container>

<router-outlet></router-outlet>

<seira-listagem-notificacoes-tab></seira-listagem-notificacoes-tab>

<!-- Nao remover componente abaixo, pois quebrará o AreaTemporariaService -->
<seira-area-temporaria />
